export default __webpack_public_path__ + "static/media/April_01.79631768.png";